var pdpMainSwiper = null;
var pdpSelectedVariant = null;
const pdpGallery = document.getElementById('pdp-gallery-swiper');
const pdpSwiperWrapper = document.getElementById('pdp-gallery-swiper-wrapper');
const pdpGallerySlidesHTML = hcDOMParser.parseFromString(pdpGallerySlidesRaw, 'text/html');
const pdpGalleryInitSlide = document.querySelector('#pdp-gallery-swiper .lcp-image');
const pdpVariantPrice = document.getElementById('pdp-variant-price');
const pdpDescription = document.getElementById('pdp-description');
const pdpOptionInputs = document.querySelectorAll('.pdp-option__input');
const pdpSpecsData = document.querySelectorAll('.pdp-spec__data[data-spec]');
const pdpRetailerLinks = document.querySelectorAll('#pdp-retailers a');
const pdpSamples = document.querySelectorAll('.pdp-sample');
const pdpAudioButtons = document.querySelectorAll('.pdp-audio-button');
const pdpB2L = document.getElementById('b2lbibletlayer_0');
const pdpContributors = document.querySelectorAll('.pdp-contributor');

function pdpSetSelectedVariant(){
  var selectedOptions = Array.from(pdpOptionInputs).filter(el => el.checked).map(el => el.value);
  var variantSet = pdpVariants;
  for (var x = 0; x < pdpOptions.length; x++) {
    variantSet = variantSet.filter(v => v.options[x] == selectedOptions[x]);
  }
  pdpSelectedVariant = variantSet[0];
}

function pdpGetActiveSlides(){
  const variantSlides = pdpGallerySlidesHTML.querySelectorAll(`[data-variant="${pdpSelectedVariant.id}"]`);
  const allVariantsSlides = pdpGallerySlidesHTML.querySelectorAll(`[data-variant="all"]`);
  const combinedSlides = Array.from(variantSlides).concat(Array.from(allVariantsSlides));
  return combinedSlides;
}

function pdpUpdateGallerySlides(slides,init = false){
  if(!init){
    pdpMainSwiper.removeAllSlides();
  }
  slides.forEach((slide) => {
    if(init && slide.id == pdpGalleryInitSlide.id){return};
    pdpMainSwiper.appendSlide(slide.outerHTML);
  });
  pdpMainSwiper.update();
  pdpMainSwiper.slideTo(0);
}

pdpSetSelectedVariant();

window.addEventListener('DOMContentLoaded',() => {

  const initSlides = pdpGetActiveSlides();

  pdpMainSwiper = new Swiper('#pdp-gallery-swiper',{
    keyboard: true,
    slidesPerView: 1,
    observer: true,
    observeParents: true,
    observeSlideChildren: true,
    navigation: {
      nextEl: '#pdp-gallery-swiper .swiper-button-next',
      prevEl: '#pdp-gallery-swiper .swiper-button-prev'
    },
    pagination: {
      el: "#pdp-gallery-swiper .swiper-pagination", clickable: true
    }
  });

  pdpUpdateGallerySlides(initSlides,true);


  // Init events
  pdpAudioButtons.forEach((button) => {
    button.addEventListener('click',() => {
      var audioEl = document.getElementById(button.getAttribute('aria-controls'));
      var audioPlayer = audioEl.querySelector('audio');
      var audioPlayerSource = audioPlayer.querySelector('source');
      audioPlayerSource.src = audioPlayerSource.dataset.src;
      audioPlayer.load();
      audioEl.classList.add('active');
      audioPlayer.setAttribute('tabindex','0');
      audioPlayer.focus();
      button.setAttribute('tabindex','-1');
    });
  })
});

class VariantButtons extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    var self = this;
    self.radios = self.querySelectorAll('input[type="radio"]')
    self.radios.forEach((input) => {
      input.addEventListener('change', (event) => {
        self.onChange();
      });
    });
    self.updateRetailers();
  }

  onChange(){
    pdpSetSelectedVariant();
    if(!pdpSelectedVariant){return}

    this.updateText();
    this.updateGallery();
    this.updateSpecs();
    this.updateRetailers();
    this.updateSamples();
    this.updateContributors();
    window.history.replaceState({ }, '', `${window.location.pathname}?variant=${pdpSelectedVariant.id}`);
    hcAriaLive.textContent = pdpPageUpdated;
  }

  updateText() {
    if(pdpSelectedVariant.description != null){
      pdpDescription.innerHTML = pdpSelectedVariant.description;
    } else {
      pdpDescription.innerHTML = pdpProductDescription;
    }
  }

  updateSpecs(){
    pdpVariantPrice.textContent = hcPriceFormatter.format(pdpSelectedVariant.price / 100);
    pdpSpecsData.forEach((td) => {
      const specProp = td.dataset.spec || '';
      if(specProp == ''){return};
      const specData = pdpSelectedVariant[specProp];
      const specRow = td.closest('tr');
      if (specProp == 'download') {
        const link = td.getElementsByTagName('a')[0];
        if (link) {
          link.outerHTML = specData;
        }
      } else if (specData) {
        td.textContent = specData;
        specRow.classList.remove('hide');
      } else {
        td.textContent = '';
        specRow.classList.add('hide');
      }
    });
  }

  updateGallery(){
    const activeSlides = pdpGetActiveSlides();
    pdpUpdateGallerySlides(activeSlides);
  }

  updateSamples(){
    pdpSamples.forEach((el) => {
      el.classList.add('hide');
    });
    pdpAudioButtons.forEach((button) => {
      button.setAttribute('tabindex','-1');
    });
    if(pdpSelectedVariant.audio_file){
      const audioEl = document.getElementById(`pdp-audio-${pdpSelectedVariant.id}`);
      if(audioEl){
        const audioButton = audioEl.querySelector('button');
        audioButton.setAttribute('tabindex','0');
        audioEl.classList.remove('hide');
      }
      pdpB2L.classList.add('hide');
    } else {
      pdpB2L.classList.remove('hide');
    }
  }

  hideDigitalMediaAnchorTag(anchor) {
    const allowedOptions = anchor.dataset.allowedOptions;
    if(!allowedOptions){
      anchor.classList.remove('hide');
      return;
    }
    const allowed = allowedOptions.split(',').map((option) => option.trim().toLowerCase());
    const variantOptions = pdpSelectedVariant.options.map((option) => option.trim().toLowerCase());
    const isAllowed = allowed.some((option) => variantOptions.includes(option));
        console.log("options", pdpSelectedVariant.options)
            console.log("allowedOptions", allowed)
                console.log("is allowed", isAllowed)
    anchor.classList.toggle('hide', !isAllowed);
  }

  updateRetailers(){
    pdpRetailerLinks.forEach((a) => {
      this.hideDigitalMediaAnchorTag(a);
      let url = (a.dataset.url).replace('{{{ISBN}}}',pdpSelectedVariant.sku);
      a.href = url;
    });
  }

  updateContributors(){
    const currentID = pdpSelectedVariant.id.toString();
    pdpContributors.forEach((el) => {
      if(el.dataset.variant == currentID){
        el.classList.remove('hide');
      } else {
        el.classList.add('hide');
      }
    });
  }
}

customElements.define('variant-buttons', VariantButtons);
